import logoImg from "../assets/logo.png";

export default function LogoSVG({ size = 64, inv = false }) {
  return (
    <img
      src={logoImg}
      alt="LHDA Inc."
      width={size}
      height={size}
      style={{
        display: "block",
        objectFit: "contain",
        /* On dark loading-screen backgrounds apply a subtle drop-shadow
           so the white logo circle doesn't bleed into the gradient */
        ...(inv ? { filter: "drop-shadow(0 2px 8px rgba(0,0,0,.45))" } : {}),
      }}
    />
  );
}
